export const environment: {
  platformHost: string;
  production: boolean;
} = {
  platformHost:
    window.location.hostname.indexOf('.whg.tech') === -1 ? 'https://platform.iom.whitehatgaming.com' : `https://platform.iom.stg.whg.tech`,
  production: true,
};
